import { ReviewCanvasContext } from 'modules/match-video/domain/interfaces';

export type FrameCanvas = HTMLCanvasElement | OffscreenCanvas;
export type FrameContext = ReviewCanvasContext;

/** A 2D canvas of the given size — offscreen where the browser has it, so it never touches the page layout. */
export function createFrameCanvas(width: number, height: number): { canvas: FrameCanvas; ctx: FrameContext } {
  const canvas: FrameCanvas =
    typeof OffscreenCanvas === 'undefined'
      ? Object.assign(document.createElement('canvas'), { width, height })
      : new OffscreenCanvas(width, height);
  const ctx = canvas.getContext('2d') as FrameContext | null;
  if (!ctx) {
    throw new Error('2D canvas is not available');
  }
  return { canvas, ctx };
}

/** Frees the canvas backing store now instead of waiting for GC (a 1080p canvas is ~8 MB). */
export function releaseFrameCanvas(canvas: FrameCanvas): void {
  canvas.width = 0;
  canvas.height = 0;
}
